// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1ap5F","inputWrap":"Table_inputWrap__2VneQ","col":"Table_col__6Spt9","bmiTooltip":"Table_bmiTooltip__3XKSP"};